<div provide-parent-form *ngIf="playlist">
    <h2>
        <i class="fa fa-podcast"></i>{{ "RSS_FEED_CONFIGURATION" | translate }}
    </h2>

    <bb-form-element [form]="form" [label]="'AUTHOR_NAME' | translate">
        <input
            [(ngModel)]="playlist.author"
            type="text"
            name="playlist-author"
        />
    </bb-form-element>

    <bb-form-element [form]="form" [label]="'COPYRIGHT' | translate">
        <input
            [(ngModel)]="playlist.copyright"
            type="text"
            name="playlist-copyright"
        />
    </bb-form-element>

    <bb-form-element [form]="form" [label]="'LANGUAGE' | translate">
        <bb-select
            [(ngModel)]="playlist.isocode"
            [options]="languageOptions"
            name="'playlist-language'"
        ></bb-select>
    </bb-form-element>

    <bb-form-element [form]="form" [label]="'EXPLICIT' | translate">
        <bb-check
            name="playlist-explicit"
            [(ngModel)]="playlist.explicit"
            [trueValue]="'true'"
            [falseValue]="'false'"
        >
        </bb-check>
    </bb-form-element>

    <bb-form-element
        [form]="form"
        [label]="'ARTWORK' | translate"
        [helpMessage]="'HELP.APPLE_ARTWORK' | translate"
    >
        <bb-logo-selector
            #imageInput
            (change)="onChange($event)"
            name="playout-artwork"
            [useType]="'commercial'"
            [mediaTypes]="['image']"
            [(entityId)]="playlist.artworkId"
            (entityIdChange)="changedEntityId($event)"
        ></bb-logo-selector>
        <div class="message float-right" *ngIf="artworkToBigForItunes">
            <span>{{ "IMAGE_NOT_IN_SPEC_ITUNES" | translate }}</span>
        </div>
    </bb-form-element>

    <bb-form-element [form]="form" [label]="'ITUNES_CATEGORY' | translate">
        <bb-select
            [(ngModel)]="playlist.iTunesCategory"
            [options]="iTunesCategories"
            name="'playlist-iTunesCategory'"
        ></bb-select>
    </bb-form-element>

    <bb-form-element
        [form]="form"
        [label]="'OWNER_NAME' | translate"
        [helpMessage]="'HELP.APPLE_OWNER' | translate"
    >
        <input [(ngModel)]="playlist.owner" type="text" name="playlist-owner" />
    </bb-form-element>

    <bb-form-element [form]="form" [label]="'EMAIL_ADDRESS' | translate">
        <input [(ngModel)]="playlist.email" type="text" name="playlist-email" />
    </bb-form-element>

    <bb-form-element [form]="form" [label]="'EXTERNAL_URL' | translate">
        <input
            [(ngModel)]="playlist.externalUrl"
            type="text"
            name="playlist-external-url"
        />
    </bb-form-element>
</div>
